module.exports = __webpack_public_path__ + "static/media/回收站.b473c794.png";